import React, { useState, useEffect } from 'react';

import {
  Container,
  ThisCol,
  ThisCard,
  ThisCardColor,
  ScrollOS,
  Container2,
  BodyColuna2,
  ThisCard2,
  ThisCardProj2,
  ThisCardColor2,
  ThisProgress2,
} from './styles';
// import api from '~/services/api';

// import IconGroup from '~/assets/icones/IconGroup.svg';
import IconMax from '~/assets/icones/IconMax.svg';
import IconData from '~/assets/icones/IconData.svg';

function CustomBodyContent({ data, etapas, idEtapa, setIdEtapa, tipoVisual }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [projetos, setProjetos] = useState(data);
  // const [heightColBody, setHeightColBody] = useState(0);

  useEffect(() => {
    setProjetos(data);
  }, [data]);

  return tipoVisual == '1' ? (
    <Container>
      <div className="content-oc">
        <ScrollOS>
          <div className="display-oc">
            {etapas?.map((thisEtapa, i) => (
              <ThisCol key={thisEtapa?.id || i} id={thisEtapa?.id || i} index={i}>
                <div className="list-header">
                  <p className="titulo">{thisEtapa?.titulo}</p>
                  <img className="max" src={IconMax} alt="Vazio" />
                </div>
                <div className="list-body">
                  {data?.map(
                    (thisData, i) =>
                      thisData?.idEtapa == thisEtapa?.id && (
                        <ThisCard
                          className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
                          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                          key={thisData?.id || i}
                          id={thisData?.id || i}
                          index={i}
                          ativo={linhaAtiva === thisData?.id ? true : false}
                        >
                          <div className="card-header">
                            <div className="card-header-top">
                              <p className="codigo">#{thisData?.codigo}</p>
                              <div className="card-header-priori">
                                <ThisCardColor cor={thisData?.prioridade?.cor} />
                                {/* <p className="titulo">
                                  {thisData?.prioridade?.titulo}
                                </p> */}
                              </div>
                              {/* <p className="data">{((new Date(thisData?.dataProjeto).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p> */}
                            </div>
                            <p className="titulo">{thisData?.titulo}</p>
                            <p className="cliente">{thisData?.cliente?.nomeFantasia}</p>
                          </div>
                          {/* <div className="card-footer">
                            <p className="responsavel">
                              Coord.: {thisData?.coordenador?.nome}
                            </p>
                          </div> */}
                        </ThisCard>
                      ),
                  )}
                </div>
              </ThisCol>
            ))}
          </div>
        </ScrollOS>
      </div>
    </Container>
  ) : (
    <Container2>
      <div className="content-projetos">
        <div className="body">
          <BodyColuna2 className="body-left">
            {/* <BodyColuna2 className="body-left" {...{ height: heightColBody + 'em' }}> */}
            <div className="body-content">
              {etapas?.map((thisData, a) => (
                <ThisCard2 key={thisData?.id || a}>
                  <div
                    className={thisData?.id === idEtapa ? 'item ativo' : 'item'}
                    onClick={() => {
                      let dados = [];
                      for (const item of data) {
                        if (thisData?.id == item?.idEtapa) {
                          dados.push({ ...item });
                        }
                      }

                      setProjetos(dados);
                      setIdEtapa(thisData?.id);
                    }}
                  >
                    <div className="limite"></div>
                    <div className="item-colunas">
                      <div className="item-col-quant">
                        <p className="quant">{}</p>
                      </div>
                      <div className="row-coluna">
                        <p>
                          {thisData?.titulo?.length > 50
                            ? thisData?.titulo?.substr(0, 50) + '...'
                            : thisData?.titulo}
                        </p>
                      </div>
                    </div>
                  </div>
                </ThisCard2>
              ))}
            </div>
          </BodyColuna2>
          <BodyColuna2 className="body-right">
            {/* <BodyColuna2 className="body-right" {...{ height: heightColBody + 'em' }}> */}
            <div className="body-content">
              <div className="content-right">
                {projetos?.map((thisData, i) => (
                  <ThisCardProj2
                    className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
                    {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                    key={thisData?.id || i}
                    id={thisData?.id || i}
                    index={i}
                    ativo={linhaAtiva === thisData?.id ? true : false}
                  >
                    <div className="card-header">
                      <div className="card-header-top">
                        <p className="codigo">#{thisData?.codigo}</p>
                      </div>
                      <p className="titulo">{thisData?.titulo}</p>
                      <p className="cliente">{thisData?.cliente?.nomeFantasia}</p>
                    </div>
                    <div className="card-footer">
                      <div className="card-footer-top">
                        <div className="content-progress">
                          <div className="card-content">
                            <p className="titulo">
                              {thisData?.horaUsada}h/{thisData?.horaTotal}h
                            </p>
                            <div className="progress">
                              <ThisProgress2
                                backgound="#34639C"
                                width={
                                  (thisData?.horaUsada * 100) / thisData?.horaTotal > 100
                                    ? 100
                                    : (thisData?.horaUsada * 100) / thisData?.horaTotal + '%'
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer-bottom">
                        <div className="card-footer-data">
                          <div className="fundo-img">
                            <img src={IconData} alt="IconData" />
                          </div>
                          <p className="data">
                            {'De ' +
                              new Date(thisData?.previsaoInicio)
                                .toLocaleString('pt-BR', { timeZone: 'UTC' })
                                .split(',')[0]}
                            {' Até ' +
                              new Date(thisData?.previsaoEntrega)
                                .toLocaleString('pt-BR', { timeZone: 'UTC' })
                                .split(',')[0]}
                          </p>
                        </div>
                        <div className="card-footer-priori">
                          <ThisCardColor2 cor={thisData?.prioridade?.cor} />
                          <p className="titulo">{thisData?.prioridade?.titulo}</p>
                        </div>
                      </div>
                    </div>
                  </ThisCardProj2>
                ))}
              </div>
            </div>
          </BodyColuna2>
        </div>
      </div>
    </Container2>
  );
}

export default CustomBodyContent;
